<template>
  <div
    style="min-height: 100%;"
    class="c-d-flex ui-flex-col c-bg-white"
    :class="{ 'bg-color': isPretty }"
  >
    <!-- Logo e stepper -->
    <div
      v-if="isPretty"
      class="c-container"
    >
      <div class="c-row ui-pt-8">
        <!-- Logo Estratégia -->
        <div class="c-col-2 sm:c-col-2 md:c-col-2">
          <estrategia-logo />
        </div>

        <!-- Stepper -->
        <div class="c-col-2 sm:c-col">
          <p-stepper />
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="ui-flex-1 c-d-flex c-center">
      <div class="ui-w-full c-row c-horizontal-center">
        <router-view
          class="c-col-full c-bg-white ui-overflow-hidden ui-px-4 md:ui-px-8 ui-py-2"
          :class="{ 'ui-rounded-lg': isPretty }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PStepper from '@/components/p-stepper';
import EstrategiaLogo from '@/components/estrategia-logo';

export default {
  components: {
    PStepper,
    EstrategiaLogo,
  },
  computed: {
    isPretty () {
      return !!this.$route.query.pretty;
    },
  },
};
</script>

<style scoped lang="scss">
.bg-color {
  background-color: var(--c-color-primary-200);
}
</style>
